"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogoIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _Images = require("../../constants/Images");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Description: This component provides the logo to be used on the Sidebar.
 * Props:
 *  - url: URL to the page the button should redirect. Defaults to '/'
 *  - logoPath: Path to the logo to be shown on the button. Defaults to the Pollux small logo.
 *  - alt: Alternative description for the image that is shown when the user hovers over the button. Defaults to "Pollux DMS".
 *  - label: Label that should be shown on the right side of the logo. Defaults to "Pollux DMS".
 *  - textColor: Color of the label text. Defaults to "white".
 *  - isLink: Determines if the logo and label should be wrapped in a link. Defaults to true.
 *  - borderRadius: Controls the border radius of the logo. Defaults to "50%".
 *  - showLabel: Determines if the label is displayed. Defaults to true.
 */

const DmsLogoIcon = _ref => {
  let {
    url = "/",
    logoPath = _Images.IMAGES.LOGO_ICON,
    alt = "Pollux DMS",
    label = "Accenture DMS",
    textColor = "white",
    isLink = true,
    borderRadius = "50%",
    showLabel = true
  } = _ref;
  const content = /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "img",
    src: logoPath,
    alt: alt,
    sx: _objectSpread(_objectSpread({}, styles.appLogo), {}, {
      borderRadius
    })
  }), showLabel && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    component: "span",
    sx: {
      color: textColor,
      ml: 2
    }
  }, /*#__PURE__*/_react.default.createElement("b", null, label)));
  return isLink ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: url,
    style: {
      textDecoration: "none",
      color: "inherit"
    }
  }, content) : content;
};

/** @type {import("@mui/material").SxProps} */
exports.DmsLogoIcon = DmsLogoIcon;
const styles = {
  appLogo: {
    maxWidth: "100%",
    height: "auto",
    maxHeight: "40px",
    cursor: "pointer",
    objectFit: "contain"
  }
};
DmsLogoIcon.propTypes = {
  url: _propTypes.default.string,
  logoPath: _propTypes.default.string,
  alt: _propTypes.default.string,
  label: _propTypes.default.string,
  textColor: _propTypes.default.string,
  isLink: _propTypes.default.bool,
  borderRadius: _propTypes.default.string,
  showLabel: _propTypes.default.bool
};